import { IPageName } from '../../common/types/apiSchema';
import { PathMap } from './paths';

/**
 * Localised URLs for Netherlands
 */
export const NlPaths: PathMap = {
  [IPageName.collections]: ['/:filterslug/filter'],
  [IPageName.bookingsPage]: ['/boekingen'],
  [IPageName.bookingDetailsPage]: ['/boekingen/:bookingId/details'],
  [IPageName.cancellationPage]: ['/boekingen/:bookingId/cancellation'],
  [IPageName.instantAccess]: ['/direct-toegang/:affilate'],
};
